import { getReferralsApiUrl } from '../config/api';
import { isUploadTooLarge, UPLOAD_TOO_LARGE_MESSAGE } from '../lib/uploadLimits';
async function presignUpload(request) {
    const response = await fetch(getReferralsApiUrl('/uploads/presign'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request),
    });
    const rawText = await response.text();
    let payload;
    try {
        payload = JSON.parse(rawText);
    }
    catch {
        throw new Error(`Invalid JSON response (${response.status}): ${rawText.slice(0, 200)}`);
    }
    if (!response.ok || payload.error || !payload.result) {
        throw new Error(payload.error ?? `Failed to create upload URL (${response.status})`);
    }
    return payload.result;
}
/** PUT the file bytes to S3 using a short-lived presigned URL. */
export async function uploadBlobToS3(blob, options) {
    if (isUploadTooLarge(blob.size)) {
        throw new Error(UPLOAD_TOO_LARGE_MESSAGE);
    }
    const contentType = options.contentType?.trim() || blob.type || 'application/octet-stream';
    const signed = await presignUpload({
        purpose: options.purpose,
        fileName: options.fileName,
        contentType,
        sizeBytes: blob.size,
        caseId: options.caseId,
    });
    const putResponse = await fetch(signed.uploadUrl, {
        method: signed.method,
        headers: signed.headers,
        body: blob,
    });
    if (!putResponse.ok) {
        throw new Error(`S3 upload failed (${putResponse.status})`);
    }
    return {
        bucket: signed.bucket,
        key: signed.key,
        fileName: signed.fileName,
        size: blob.size,
        contentType: signed.headers['Content-Type'],
    };
}
